import { render, staticRenderFns } from "./page-16.vue?vue&type=template&id=072c4d72&scoped=true&"
import script from "./page-16.vue?vue&type=script&lang=js&"
export * from "./page-16.vue?vue&type=script&lang=js&"
import style0 from "./page-16.vue?vue&type=style&index=0&id=072c4d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c4d72",
  null
  
)

export default component.exports